/*

RajeshK 09/26/2022 2701306337 report master changes
Saikrishna 10/06/2022 2701306337 Removed unecesarry console.log statements
Rohini   10/27/2022 2701306337 Added the classname for table
*/

import React, {useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {IconButton} from '@material-ui/core';
import MouseOverPopover from '../../../../components/MousePopOver/MousePopOver';
import PageLoader from '../../../../components/PageLoader';
import {useSelector} from 'react-redux';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';


const FieldTable = ({
  recordFormatCode,
  selectedRows,
  setSelectedRows,
  values,
  handleChange,
  touched,
  errors,
  inputFieldValues,
  setInputFieldValues,
  setFieldValue,
  deletedRules,
  setDeletedRules,
}) => {
  const [loader, setLoader] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userData, setUserData] = useState(null);

  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...selectedRows];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setSelectedRows(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    const arr = [...selectedRows];
    arr.forEach((ele) => {
      delete ele.deleteState;
    });
    arr.splice(key, 1, {...arr[key], deleteState: true});
    const newDeletedIds = [...deletedRules];
    if (rowData?.memberId) {
      newDeletedIds.push(rowData?.memberId);
    }

    setSelectedRows(arr);
    setDeletedRules(newDeletedIds);
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleConfirmDelete = () => {
    setLoader(true);
    handleCloseDialog();
    setTimeout(() => {
      const arr = [...selectedRows].filter((r) => r.fieldCode !== userData.fieldCode);
      setSelectedRows(arr);
      setLoader(false);
    }, 1000);
  };

  // const handleCancel = (rowData, key) => {
  //   const arr = [...selectedRows];
  //   arr.forEach((ele) => {
  //     delete ele.deleteState;
  //   });
  //   setSelectedRows(arr);
  // };

  const {roleData} = useSelector(({role}) => role);
  const disableEdit = roleData?.window?.['Record Format']?.['RF']?.edit;
  // const disabledByRole = roleData?.window?.["Record Format"]?.["RF"]?.add;
  // const disableDelete = roleData?.window?.["Record Format"]?.["RF"]?.delete;

  // const roleAccess = roleData?.window?.["Record Format"]?.["RF"];
  // const viewOnly = !roleAccess?.edit && !roleAccess?.add && roleAccess?.read && !roleAccess?.delete;

  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'SEQ No',
    },
    {
      title: 'Field Type',
    },
    {
      title: 'Field Code',
    },
    {
      title: 'Data Type',
    },
    {
      title: 'Description',
    },
    {
      title: 'Field Header',
    },
    {
      title: 'Field Length',
      hidden: values.fixedLength === 'N',
    },
    {
      title: 'Date Format',
    },
    {
      title: 'Print Totals',
    },
  ];
  return (
    <>
      <DeleteTableRecordPopup open={isDelete} dialogClose={handleCloseDialog} title="Delete Field" 
        value={`Are you sure you want to delete this field?`} handleSubmit={handleConfirmDelete}/>
      <div className={`mui-custom-table-container global-field-table pt-0`}>
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns.map(
                  ({title, hidden = false}) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {selectedRows?.length > 0 ? (
                    selectedRows.map((rowData, key) => {
                      return (
                        // file deepcode ignore ReactMissingArrayKeys: <please specify a reason of ignoring this>
                        <Draggable draggableId={`draggable-${key}`} index={key} key={key}>
                          {(provided) =>
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <IconButton
                                  disabled={(recordFormatCode && !disableEdit)}
                                  onClick={(e) => {
                                    handleDelete(rowData, key);
                                  }}
                                >
                                  <DeleteOutlined />
                                </IconButton>
                              </td>
                              <td className="recFormat-col">{key + 1}</td>
                              <td className="recFormat-col">{rowData.fieldType}</td>
                              <td className="recFormat-col">{rowData.fieldCode}</td>
                              <td className="recFormat-col">{rowData?.dataType || '-'}</td>
                              <td className="recFormat-col">
                                {
                                  <MouseOverPopover
                                    data={rowData.description}
                                    popOverData={rowData.description}
                                    codeLength={rowData?.description?.length}
                                  />
                                }
                              </td>
                              <td className="recFormat-col">
                                {rowData.fieldHeader(
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setInputFieldValues,
                                  setFieldValue,
                                )}
                              </td>
                              {values.fixedLength !== 'N' && (
                                <td className="recFormat-col">
                                  {rowData.fieldLength(
                                    values,
                                    handleChange,
                                    touched,
                                    errors,
                                    inputFieldValues,
                                    setInputFieldValues,
                                    setFieldValue,
                                  )}
                                </td>
                              )}
                              <td className="recFormat-col">
                                {rowData.format(
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setInputFieldValues,
                                  setFieldValue,
                                  rowData.dataType,
                                  dropDownData,
                                )}
                              </td>
                              <td className="recFormat-col">
                                {rowData.printTotals(
                                  values,
                                  handleChange,
                                  touched,
                                  errors,
                                  inputFieldValues,
                                  setInputFieldValues,
                                  setFieldValue,
                                )}
                              </td>
                            </tr>
                          }
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>No records to display</td>
                    </tr>
                  )}
                  {provided.placeholder}
                  {loader && <PageLoader />}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default FieldTable;
